export default __webpack_public_path__ + "static/media/060_corner2.first.08bae3b5.avif";